import * as types from '../constants/actionTypes';
import { GraphFilters, FundTypes, SignUpInfo } from '../models';
import { PlanHolder, Beneficiary } from '../models/applicationForm';

const updateFundFilter = (filter: GraphFilters) => ({
  type: types.UPDATE_FUND_FILTER,
  filter
});

const setDigitalFund = (fund: FundTypes) => ({
  type: types.SET_DIGITAL_FUND,
  fund
});

const setCapitalFund = (fund: FundTypes) => ({
  type: types.SET_CAPITAL_FUND,
  fund
});

const allocateFundSplit = (capitalPercentage: number) => ({
  type: types.ALLOCATE_FUND_SPLIT,
  capitalPercentage
});

const setLumpSum = (amount: number) => ({
  type: types.SET_LUMPSUM,
  amount
});

const setMonthlyContribution = (amount: number) => ({
  type: types.SET_MONTHLY_CONTRIBUTION,
  amount
});

const setDuration = (years: number) => ({
  type: types.UPDATE_DURATION,
  years
});

const signUp = (info: SignUpInfo) => ({
  type: types.SIGN_UP,
  info
});

const signUpSuccess = () => ({
  type: types.SIGN_UP_SUCCESS
});

const signUpFailure = (errorMessage: string) => ({
  type: types.SIGN_UP_FAILURE,
  errorMessage
});

const toggleWalkthroughComplete = (isComplete: boolean) => ({
  type: types.TOGGLE_WALKTHROUGH_COMPLETE,
  isComplete
});

const setPlanholder = (planholder: PlanHolder) => ({
  type: types.UPDATE_LOCAL_PLANHOLDER,
  planholder
});

const setBeneficiary = (beneficiary: Beneficiary) => ({
  type: types.UPDATE_LOCAL_BENEFICIARY,
  beneficiary
});

export {
  updateFundFilter,
  setDigitalFund,
  setCapitalFund,
  allocateFundSplit,
  setLumpSum,
  setMonthlyContribution,
  setDuration,
  signUp,
  signUpSuccess,
  signUpFailure,
  toggleWalkthroughComplete,
  setPlanholder,
  setBeneficiary
}
